import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Modal } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { saveTrainerMaster } from "../../services/Trainer/TrainerServices";
import { CloseModalIcon } from "../../../../../common/components/assets/commonassets/CommonAssets";
import CommonDivider from "../../../../../common/components/divider/CommonDivider";
import InputField from "../../../../../common/components/FormFields/InputField";
import CheckBoxField from "../../../../../common/components/FormFields/CheckBoxField";
import CommonButton from "../../../../../common/components/Buttons/CommonButton";
import CommonBackDrop from "../../../../../common/components/CommonBackDrop/CommonBackDrop";
import ConfirmationModal from "../../../../../common/components/ConfirmationModal";
import { CapitalizeStatement } from "../../../../../common/components/Custom Hooks/CapitalizeStatement";
import { errorAlert, successAlert } from "../../../../../common/components/Toasts/CustomToasts";



const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "45%",
  maxHeight: "90vh",
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  display: "flex",
  flexDirection: "column",
  Padding: 2,
};

const TrainerModal = ({
  trainerModalOpen,
  setTrainerModalOpen,
  selectedRow,
  setSelectedRow,
  populateTable,
  setOpenBackdrop,
  openBackDrop,
}) => {
  const defaultValues = {
    Trainer: "",
    status: true,
  };
  const [openPostModal, setOpenPostModal] = useState(false);
  const [finalData, setFinalData] = useState([]);

  const schema = yup.object().shape({
    Trainer: yup.string().required("this field is required"),
  });
  const {
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm({ defaultValues, resolver: yupResolver(schema) });

  const onSubmit = (data) => {
    setOpenPostModal(true);
    let obj = {
      id:selectedRow!==null?selectedRow?.Id:null,
      trainerName: CapitalizeStatement(data?.Trainer),
      isActive: data?.status,
    };
    setFinalData(obj);
  };

  const handleSaveRecord = () => {
    setOpenBackdrop(true);
    setOpenPostModal(false);
    saveTrainerMaster(finalData)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 201 || res.statusCode === 200) {
          setTrainerModalOpen(false);
          populateTable();
          setSelectedRow(null);
          successAlert(res.message);
          setOpenBackdrop(false);
          reset(defaultValues);
        }
      })
      .catch((error) => {
        errorAlert(error.message);
        setOpenBackdrop(false);
      });
  };

  useEffect(() => {
    if (selectedRow !== null) {
      setValue("Trainer", selectedRow?.["Trainer Name"]);
      setValue("status", selectedRow?.Status);
    } else {
      reset(defaultValues);
    }
  }, [selectedRow]);

  return (
    <>
      <Modal
        open={trainerModalOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box sx={modalStyle} className="w-[40%] p-2 rounded-xl">
            <div className="flex justify-between ">
              <h1 className="font-semibold text-[17px] ">
                {selectedRow !== null ? "Update Trainer" : "New Trainer"}
              </h1>
              <CloseModalIcon
                type="button"
                className="closeButton"
                onClick={() => {
                  setTrainerModalOpen(false);
                  setSelectedRow(null);
                  reset(defaultValues);
                }}
              />
            </div>
            <CommonDivider color="E0E0E0" />

            <div className=" gap-2 mt-3 gap-y-6">
              <div className="grid grid-cols-[60%_40%] gap-4">
                <InputField
                  label="Trainer*"
                  name="Trainer"
                  control={control}
                  defaultValue=""
                  error={errors.Trainer}
                />
                <CheckBoxField
                  control={control}
                  name="status"
                  defaultValue={true}
                  label="Active"
                />
              </div>
            </div>
            <div className="flex gap-2 mt-4 justify-end items-center ">
              <CommonButton
                label="Reset"
                onClick={() => reset(defaultValues)}
                className="resetButton px-6 py-2 border border-red-500 text-red-500"
              />
              <CommonButton
                label={selectedRow !== null ? "Update" : "Save"}
                type="submit"
                className="px-6 py-2 bg-green-700 text-white text-base"
              />
            </div>
          </Box>
          {openBackDrop && <CommonBackDrop openBackdrop={openBackDrop} />}
        </form>
      </Modal>
      <ConfirmationModal
        confirmationOpen={openPostModal}
        confirmationHandleClose={() => setOpenPostModal(false)}
        confirmationLabel="Confirmation"
        confirmationMsg={`Are you sure you want to ${
          selectedRow !== null ? "update" : "save"
        } this record?`}
        confirmationSubmitFunc={() => {
          handleSaveRecord();
        }}
        confirmationButtonMsg="Save"
      />
    </>
  );
};

export default TrainerModal;